import React from 'react';
import PropTypes from 'prop-types';

//  Lodash
import _noop from 'lodash/noop';

// Components
import KebabMenu from '../../../../KebabMenu';
var ActionsMenu = function ActionsMenu(props) {
  var menuItems = props.menuItems,
    placement = props.placement,
    onClickAction = props.onClickAction;
  var triggerElement = /*#__PURE__*/React.createElement("span", {
    className: "icon-overflow icon-header-menu-overflow pointer"
  });
  return /*#__PURE__*/React.createElement(KebabMenu, {
    onClickAction: onClickAction,
    menuItems: menuItems,
    triggerElement: triggerElement,
    placement: placement
  });
};
ActionsMenu.propTypes = {
  menuItems: PropTypes.array.isRequired,
  placement: PropTypes.string,
  onClickAction: PropTypes.func
};
ActionsMenu.defaultProps = {
  placement: 'bottomLeft',
  onClickAction: _noop
};
export default ActionsMenu;